var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OTabs',{staticClass:"vast-filter-by-selected-countries",attrs:{"tabs":_vm.tabs},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }